/* --------------------------------------------------------------------------------------
   imageLoaded.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

 export class imageLoaded {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {
      loaded: '&'
    }
  }
  link(scope, elem, attrs) {
    elem.bind('load', (e) => {
      scope.loaded()
    })
  }
  static directiveFactory() {
    imageLoaded.instance = new imageLoaded()
    return imageLoaded.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/common/directives/imageLoaded.directive.js